export const system = "Smart" as const;
